import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { ProductionGroup } from '@paragon/contract-library';

interface ProductionGroupsState {
  [productionGroupGuid: string]: ProductionGroup;
}

const initialState: ProductionGroupsState = {};

const productionGroupsSlice = createSlice({
  name: 'productionGroups',
  initialState,
  reducers: {
    productionGroupsLoaded: (state, action: PayloadAction<readonly ProductionGroup[]>) => {
      for (const batch of action.payload) {
        state[batch.guid] = castDraft(batch);
      }
    },
  },
});

export const { productionGroupsLoaded } = productionGroupsSlice.actions;
export const productionGroups = productionGroupsSlice.reducer;
